// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_fW","advertDetailHeaderLocation__value":"c-m_fX"};